export default "__VITE_ASSET__CxH0tE0___"